import React, { memo, SVGProps } from 'react'

export const PencilNotEditable = memo((props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="M14.563 3.99936L12.6555 5.90688C12.6488 5.9136 12.6469 5.9232 12.6401 5.93088L4.57805 13.992C4.48781 14.0822 4.42349 14.1936 4.39085 14.3174L3.02381 19.4947C2.95853 19.7424 3.02957 20.0064 3.21101 20.1878C3.34829 20.3251 3.53165 20.399 3.71981 20.399C3.78125 20.399 3.84269 20.3914 3.90317 20.375L9.08045 19.008C9.20333 18.9754 9.31565 18.911 9.40589 18.8218L17.492 10.7434C17.4987 10.7366 17.5016 10.7261 17.5083 10.7194L19.3957 8.832C20.7281 7.49952 20.7281 5.33184 19.3957 3.99936C18.0632 2.66688 15.8955 2.66688 14.563 3.99936ZM8.52557 17.665L4.73165 18.6662L5.73293 14.8723L13.1681 7.43712L15.9637 10.2326L8.52461 17.664L8.52557 17.665ZM18.3781 7.81344L16.9803 9.2112L14.1838 6.41568L15.5816 5.01792C16.3525 4.24608 17.6072 4.24704 18.3781 5.01792C19.1489 5.7888 19.1489 7.0416 18.3781 7.81344Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.24033 4.24032C4.56076 3.91989 5.08028 3.91989 5.40071 4.24032L19.7597 18.5993C20.0801 18.9197 20.0801 19.4392 19.7597 19.7597C19.4393 20.0801 18.9197 20.0801 18.5993 19.7597L4.24033 5.4007C3.9199 5.08027 3.9199 4.56075 4.24033 4.24032Z"
      fill="currentColor"
    />
  </svg>
))
